import { AlertSeverity } from '@rover/react-lib/src/components/notifications/Alert/Alert';
import { PriceTransparencyLevels } from '@rover/types/src/PriceTransparencyLevel';

import {
  AlertContentEnum,
  getAlertContent,
  getLiteAlertContentType,
  getSubHeader,
  HEADER_TITLES,
  HeaderIconEnum,
  HeaderTitlesEnum,
  SubHeadersEnum,
} from './constants';
import { BestMatchBuilderProps, PrebuiltHeaderProps } from './types';

const buildBestMatchesHeader = (props: BestMatchBuilderProps): PrebuiltHeaderProps | object => {
  const { startDate, endDate } = props.dateData;
  const hasDates = !!startDate && !!endDate;
  const petCount = props.petCount || 0;

  let primarySubheader: string | undefined;
  let secondarySubheader: string | undefined;
  let alertText: string | undefined;

  if (props.priceTransparencyLevel === PriceTransparencyLevels.none) {
    primarySubheader = hasDates
      ? getSubHeader(SubHeadersEnum.SEEING_PROVIDERS_DATES, props)
      : getSubHeader(SubHeadersEnum.ADD_DATES, props);

    if (props.hasBestMatches) {
      secondarySubheader = getSubHeader(SubHeadersEnum.BEST_MATCH_LIST_SHORT_LEAD_TIME, props);
    }
  } else if (
    props.priceTransparencyLevel === PriceTransparencyLevels.full ||
    props.priceTransparencyLevel === PriceTransparencyLevels.lite
  ) {
    if (props.hasBestMatches) {
      primarySubheader = getSubHeader(SubHeadersEnum.BEST_MATCH_LIST_SHORT_LEAD_TIME, props);
    }

    if (props.priceTransparencyLevel === PriceTransparencyLevels.full) {
      alertText = hasDates
        ? getAlertContent(AlertContentEnum.PRICE_TRANSPARENCY_FULL_PRICES_FOR_UNIT, props)
        : getAlertContent(AlertContentEnum.PRICE_TRANSPARENCY_FULL_ADD_DATES, props);
    } else {
      const contentType = getLiteAlertContentType(
        hasDates,
        petCount,
        props.isPetCountersExperiment
      );
      alertText = getAlertContent(contentType, props);
    }
  }

  return {
    icon: HeaderIconEnum.BOLT,
    title: HEADER_TITLES()[HeaderTitlesEnum.BEST_MATCHES],
    primarySubheader,
    secondarySubheader,
    alertText,
    alertSeverity: AlertSeverity.INFO,
    isBestMatchHeader: true,
  };
};

export default buildBestMatchesHeader;
